import React from "react";
import * as Fi from "react-icons/fi";

export default function IconByName({ name, className }) {
  const key = `Fi${name?.trim() || ""}`;
  const Cmp = Fi[key] || Fi.FiFileText;
  return <Cmp className={className} />;
}
